export const TeamType = Object.freeze({
  Regular: 'Regular',
  Subsidiary: 'Subsidiary',
  Division: 'Division',
});
